import Numeral from 'numeral';
import 'numeral/locales/no';
import React from 'react';

import { StandardButton } from '@eika/button';
import { MediumCenteredContainer } from '@eika/engine-view';
import { Link, LinkType } from '@eika/link';
import { LinkPanel } from '@eika/link-panel';

import { ButtonClickEvent, StringKeyValue } from '../../actions/types';
import { CardsReducer } from '../../reducers/cards';

// Norwegian Locale
Numeral.locale('no');

interface Props {
    text: StringKeyValue;
    hasGold: boolean;
    hasBusiness: boolean;
    goldCard: CardsReducer['goldCard'];
    businessCard: CardsReducer['businessCard'];
    canHaveGold: boolean;
    canHaveBusiness: boolean;
    showCustomButton: boolean;
    buttonText: string;
    buttonEvent: (e: ButtonClickEvent) => void;
    dialogHeaderTitle: string;
    dialogBodyText: string;
    showCardButtons: boolean;
    lbsbnr: string | null;
    appType: string;
}

const DialogContent = (props: Props): JSX.Element => {
    const {
        text,
        hasGold,
        hasBusiness,
        canHaveGold,
        canHaveBusiness,
        goldCard,
        businessCard,
        buttonText,
        showCustomButton,
        buttonEvent,
        dialogHeaderTitle,
        dialogBodyText,
        showCardButtons,
        lbsbnr,
        appType,
    } = props;

    const {
        dialogButtonGold,
        dialogButtonBusiness,
        cardNameGold,
        cardNameBusiness,
        dialogTitle,
        dialogCreditLimit,
        dialogIncreaseButtonText,
    } = text;

    const getApplicationUrl = (type: string, endre: number): string => {
        const lbsSuffix = lbsbnr !== null ? `&lbsbnr=${lbsbnr}` : '';
        return `?type=${type}&endre=${endre}${lbsSuffix}`;
    };

    return (
        <MediumCenteredContainer>
            <article className="card">
                <div className="dialog">
                    {dialogTitle && dialogHeaderTitle !== '' && (
                        <h1 className="dialog-title">{dialogHeaderTitle || dialogTitle}</h1>
                    )}
                    {dialogBodyText && <p>{dialogBodyText}</p>}
                    {showCardButtons && (
                        <div className="dialog-cards">
                            {hasGold && goldCard && (
                                <div className="dialog-cards-item">
                                    <div className="dialog-cards-item__title">{cardNameGold}</div>
                                    <div>{dialogCreditLimit}</div>
                                    <h2 className="dialog-cards-item__credit">
                                        {Numeral(goldCard.kredittgrense).format('0,0')} kr
                                    </h2>
                                    <div className="dialog-cards-item__button">
                                        <Link
                                            href={getApplicationUrl('gold', 1)}
                                            linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                                        >
                                            {dialogIncreaseButtonText}
                                        </Link>
                                    </div>
                                </div>
                            )}
                            {hasBusiness && businessCard && appType !== 'eika' && (
                                <div className="dialog-cards-item">
                                    <div className="dialog-cards-item__title">{cardNameBusiness}</div>
                                    <div>{dialogCreditLimit}</div>
                                    <div className="dialog-cards-item__credit">
                                        {Numeral(businessCard.kredittgrense).format('0,0')} kr
                                    </div>

                                    <div className="dialog-cards-item__button">
                                        <Link
                                            href={getApplicationUrl('business', 1)}
                                            linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                                        >
                                            {dialogIncreaseButtonText}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!hasBusiness && canHaveBusiness && (
                                <>
                                    <LinkPanel url={getApplicationUrl('business', 0)} title={dialogButtonBusiness} />
                                </>
                            )}

                            {!hasGold && canHaveGold && (
                                <>
                                    <LinkPanel url={getApplicationUrl('gold', 0)} title={dialogButtonGold} />
                                </>
                            )}

                            <div>
                                {buttonText && showCustomButton && (
                                    <div className="dialog-body__button">
                                        <StandardButton onClick={buttonEvent}>{buttonText}</StandardButton>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </article>
        </MediumCenteredContainer>
    );
};

export default DialogContent;
